export const FETCH_SESSION = "FETCH_SESSION";
export const FETCH_SESSION_REQUEST = "FETCH_SESSION_REQUEST";
export const FETCH_SESSION_SUCCESS = "FETCH_SESSION_SUCCESS";
export const FETCH_SESSION_FAILURE = "FETCH_SESSION_FAILURE";
